import { api } from "@/lib/api";

export async function listUsers({ includeInactive = false } = {}) {
  const { data } = await api.get("/admin/users", {
    params: { include_inactive: includeInactive },
  });
  return data;
}

export async function createUser(payload) {
  const { data } = await api.post("/admin/users", payload);
  return data;
}

export async function updateUser(id, payload) {
  const { data } = await api.patch(`/admin/users/${id}`, payload);
  return data;
}

export async function deleteUser(id) {
  const { data } = await api.delete(`/admin/users/${id}`);
  return data;
}

export async function resetPassword(id, newPassword) {
  const { data } = await api.post(`/admin/users/${id}/reset-password`, {
    new_password: newPassword || null,
  });
  return data;
}

export async function updateMe(payload) {
  const { data } = await api.patch("/auth/me", payload);
  return data;
}

// --- Admin alert moderation (soft delete) ---

export async function adminDeleteAlert(id) {
  const { data } = await api.delete(`/admin/alerts/${id}`);
  return data;
}

export async function adminBulkDeleteAlerts(ids) {
  const { data } = await api.post("/admin/alerts/bulk-delete", { ids });
  return data;
}

export async function adminPurgeBefore({ before, status = "all", level = "all" }) {
  const { data } = await api.post("/admin/alerts/purge-before", {
    before,
    status,
    level,
  });
  return data;
}

export async function adminPurgePreview({ before, status = "all", level = "all" }) {
  const { data } = await api.get("/admin/alerts/purge-preview", {
    params: { before, status, level },
  });
  return data;
}

export async function adminRestoreAlert(id) {
  const { data } = await api.post(`/admin/alerts/${id}/restore`);
  return data;
}

// --- Admin alert / user HARD delete (irreversible) ---

export async function adminHardDeleteAlert(id) {
  const { data } = await api.delete(`/admin/alerts/${id}/hard`);
  return data;
}

export async function adminBulkHardDeleteAlerts(ids) {
  const { data } = await api.post("/admin/alerts/bulk-hard-delete", { ids });
  return data;
}

export async function adminEmptyTrash() {
  const { data } = await api.post("/admin/alerts/empty-trash");
  return data;
}

export async function adminHardDeleteUser(id) {
  const { data } = await api.delete(`/admin/users/${id}/hard`);
  return data;
}

export async function listAlertsAdmin({
  status = "closed",
  level = "all",
  limit = 50,
  skip = 0,
  includeDeleted = false,
} = {}) {
  const { data } = await api.get("/alerts", {
    params: { status, level, limit, skip, include_deleted: includeDeleted },
  });
  return data;
}
